export default "__VITE_ASSET__qthvTzGk__"